import React from 'react';
import HeroSection from '../../component/herosection';
import Collection from '../../component/collection';
import Partners from '../../component/partners';
import Footer from '../../component/footer';
import { Helmet } from 'react-helmet-async';
import Contact from '../../component/contact-form';

const HomePage = () => {
    return (
        <>
            <Helmet>
                <title>Shareeftex - PPE Manufacturer</title>
                <meta name="description" content="Head to Toe Safety PPE Supplier. Shareef Tex  is a leading safety product manufacturer 
                offering a comprehensive portfolio of PPE including gloves, boots, high-visibilty clothing, eyewear, 
                coveralls & hats. We ensure quality and compliance for all your workplace safety needs" />
                <meta name="keywords" content="Safety equipment, PPE supplies, safety gloves, work boots, high-visibilty clothing, 
                safety glasses, coveralls, hard hats, Shareef Tex, ppe, safety, safety equipment, safety products, 
                safety gear, safety gloves, safety boots, safety clothing, safety eyewear, safety coveralls, safety hats,
                safety helmets, safety masks, safety respirators, safety vests, safety jackets, safety shirts, 
                safety pants, safety suits, safety aprons, safety tapes, safety barricades, safety barriers, 
                safety bollards, safety cones, safety tapes, safety barricades, safety barriers, safety bollards, 
                chemical resistant gloves, ppe, construction ppe, ppe gear, safety equipment suppliers, personal protection devices, ppe equipment"></meta>
                <meta name="author" content="Shareef Tex"></meta>
                <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
                <link rel="canonical" href="/"></link>
            </Helmet>
            <HeroSection/>
            <Collection/>
            <Partners/>
            <Contact/>
            <Footer/>
        </>
    );
};

export default HomePage;